<template>
    <div class="page-content">
        <PageHeader title="广告数据报表">
            <template slot="extra">
                <el-button v-if="!loadTable" icon="el-icon-download" @click="handleExport">数据导出</el-button>
            </template>
        </PageHeader>
        <div class="page-scroll-box" style="overflow: hidden;">
            <div class="filter-box">
                <div class="filter-box-row">
                    <div class="filter-item">
                        <label class="label">日期筛选</label>
                        <el-date-picker
                            v-model="filterForm.dateRange"
                            type="daterange"
                            clearable
                            value-format="yyyy-MM-dd"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            size="mini"
                            style="width: 260px;"
                        ></el-date-picker>
                    </div>
                </div>
                <div class="filter-box-row">
                    <div class="filter-item">
                        <label class="label">操作系统</label>
                        <el-select
                            v-model="filterForm.os"
                            size="small"
                            placeholder="请选择操作系统"
                            clearable
                        >
                            <el-option
                                v-for="(v, i) in osOptions"
                                :key="i"
                                :value="v.value"
                                :label="v.label"
                            />
                        </el-select>
                    </div>
                </div>
                <div class="filter-box-row">
                    <div class="filter-item" v-if="dataLevels.includes('1') || dataLevels.includes('2')">
                        <label class="label">媒体栏位</label>
                        <PopAllSelect
                            v-if="dataLevels.includes('1')"
                            v-model="filterForm.mediaIds"
                            style="margin-right: 10px;"
                            class-name="data-filter-item"
                            placeholder="媒体名称/ID"
                            :options="mediaOptions"
                            :showValue="true"
                            :hasAll="false"
                            :remote="true"
                            :loading="optionLoading"
                            :size="'mini'"
                            :remote-method="handleMediaRemoteMethod"
                            @visible-change="handleMediaRemoteMethod('')"
                        />
                        <PopAllSelect
                            v-if="dataLevels.includes('2')"
                            v-model="filterForm.adslotIds"
                            placeholder="代码位名称/ID"
                            class-name="data-filter-item"
                            :options="adslotOptions"
                            labelName="qunion_adslot_name"
                            :showValue="true"
                            :hasAll="false"
                            :remote="true"
                            :loading="optionLoading"
                            :size="'mini'"
                            :remote-method="handleAdslotRemoteMethod"
                            @visible-change="handleAdslotRemoteMethod('')"
                        />
                    </div>
                    
                    <div class="filter-item" style="margin-left: 10px;">
                        <el-button type="primary" @click="handleSearch" size="mini">查询</el-button>
                        <el-button @click="handleClear" size="mini">清空</el-button>
                    </div>
                </div>
                <div class="tabs" style="display: flex; justify-content: space-between; align-items: baseline;">
                    <div>
                        <span style="color:#4F90FF;margin-right: 20px; font-size: 14px;">详情数据</span>
                        <span style="font-size: 14px;">常见问题</span>
                        <el-tooltip class="item" effect="dark" placement="right">
                            <div slot="content">去重规则<br/>展示规则： <br/>1. 同一次请求返回的广告，即使被多次展示，也仅计为一次有效展示。客户端可重复上报展示事件，服务端将进行去重处理，仅保留一次有效展示。<br/>
                                2. 同一次请求成功返回的广告，若在有效期（1小时）后才展示给用户，则不计入展示量。<br/>
                                
                                点击规则：<br/>- 同一次请求返回的广告，在一次展示过程中即使被多次点击，也仅计为一次有效点击。
                            </div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                    <div class="button-right">
                        <el-button size="small" icon="el-icon-setting" @click="showCustomColumn">自定义列</el-button>
                    </div>
                </div>
            </div>
            
            <div class="table-list" style="width: 99%;">
                <qgm-table
                    ref="tableData"
                    v-loading="loadTable"
                    :data="listData.list"
                    :show-summary="true"
                    :summary-method="getSummaries"
                    :scroll-top-padding="60"
                    :border="false"
                    :scroll-container="'.page-content'"
                    :scroll-table="'.tabs'"
                    @sort-change="handleSortChange"
                >
                    <template v-for="column in listData.head">
                        <qgm-table-column
                            :key="column"
                            :prop="column"
                            min-width="110"
                            :fixed="['dt'].includes(column)"
                            :sortable="columnsSort.includes(column) ? 'custom' : false"
                        >
                            <template slot="header">
                                <span>{{ allColumnsO[column].label }}</span>
                                <el-tooltip v-if="allColumnsO[column].toolTip" class="item" effect="dark"
                                            :content="allColumnsO[column].toolTip" placement="right">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </template>

                            <template slot-scope="scope">
                                <template v-if="['os'].includes(column)">
                                    {{ scope.row.os_text || '' }}
                                </template>
                                <template v-else>
                                    {{ scope.row[column] }}
                                </template>
                            </template>
                        </qgm-table-column>
                    </template>
                </qgm-table>
            </div>
            <div class="pagination-box">
                <el-pagination
                    :current-page.sync="params.page"
                    :page-size.sync="params.page_size"
                    :page-sizes="pageSize"
                    layout="sizes, total, prev, pager, next"
                    :total="listData.total"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageChangeHandle"
                />
            </div>
        </div>
        
        <!--自定义列-->
        <el-dialog
            class="custom-column-dialog"
            title="自定义列"
            :visible="columnVisible"
            width="fit-content"
            :before-close="handleClose"
        >
            <div class="content">
                <div ref="selectBox" class="select-box">
                    <template v-for="item in columns">
                        <div :key="item.key" class="select-part">
                            <el-checkbox
                                v-model="item.isCheckAll"
                                class="checkbox-item all"
                                :indeterminate="item.indeterminate"
                                @change="handleCheckAllChange(item, ...arguments)"
                            >
                                {{ item.label }}
                            </el-checkbox>
                            <el-checkbox-group v-model="item.selectedValue">
                                <el-row v-for="(group, index) in item.children" :key="index">
                                    <template v-for="child in group">
                                        <el-col :key="child.value" :ref="child.value" :span="8">
                                            <el-checkbox
                                                class="checkbox-item"
                                                :label="child.value"
                                                :disabled="child.disabled"
                                                @change="handleCheckChange(item, ...arguments)"
                                            >
                                                {{ child.alias || child.label }}
                                                <el-tooltip v-if="child.tip" :content="child.tip" placement="top">
                                                    <i class="el-icon-info"/>
                                                </el-tooltip>
                                            </el-checkbox>
                                        </el-col>
                                    </template>
                                </el-row>
                            </el-checkbox-group>
                        </div>
                    </template>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="handleClose">取消</el-button>
                <el-button size="small" type="primary" plain @click="handleReset">重置</el-button>
                <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment';
import PageHeader from '@/components/PageHeader';
import PopAllSelect from '@/components/Filter/PopAllSelect'
import { getMediaByKey, getAdslotByKey, getAdvDataList, downloadAdvDataList } from '@/apis/data.js';
import { getCommonDict } from '@/apis/common.js';
import { osOptions, AllColumns } from './config/index';
import './index.scss';

export default {
    components: {
        PageHeader,
        PopAllSelect
    },

    data() {
        const defaultDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
        return {
            adReqAuth: false, // 自定义列: 广告请求&填充
            dataLevels: [],
            mediaOptions: [],
            adslotOptions: [],
            optionLoading: false,
            columns: [],
            columnsSort: [],
            columnsParams: [],
            totalInfo: {},
            downloadDisable: false,
            columnVisible: false,
            loadTable: true,
            pageSize: [20, 50, 100],
            params: {
                page: 1,
                page_size: 20,
                start_date: defaultDate,
                end_date: defaultDate,
                columns: '',
                order_by: '',
                query_condition: {}
            },
            allColumnsO: {},
            osOptions: [...osOptions],
            filterForm: {
                dateRange: [defaultDate, defaultDate],
                os: '',
                income_type: '',
                mediaIds: '',
                adslotIds: ''
            },
            optionTypes: [],
            listData: {
                head: [],
                list: [],
                currentPage: 1,
                total: 0
            }
        }
    },
    created() {
        let userInfo = this.$ls.get('userInfo');
        if (userInfo) {
            this.dataLevels = (userInfo.data_levels || '').split(',')
            this.adReqAuth = !!userInfo.auth.req_win_data_auth;
        }
        this.handleReset()
        this.getIncomeType()
        this.getList()
    },
    methods: {
        formatParams() {
            const {dateRange, os, income_type, mediaIds, adslotIds} = this.filterForm;
            if (dateRange.length > 0) {
                this.params.start_date = dateRange[0]
                this.params.end_date = dateRange[1]
            }
            if (os === '') {
                delete this.params.query_condition.os;
            } else {
                this.params.query_condition.os = os;
            }
            if (this.columnsParams.length > 0) {
                this.params.columns = this.columnsParams.join(',')
            }
            if (income_type) {
                this.params.query_condition.income_type = income_type;
            } else {
                delete this.params.query_condition.income_type
            }
            if (mediaIds && mediaIds !== -1 && mediaIds.length) {
                this.params.query_condition.media_id = mediaIds.join(',');
            } else {
                delete this.params.query_condition.media_id
            }
            if (adslotIds && adslotIds.length) {
                this.params.query_condition.adslot_id = adslotIds.join(',');
            } else {
                delete this.params.query_condition.adslot_id
            }
        },
        
        async getList() {
            this.loadTable = true;
            this.formatParams()
            console.log('params', this.params)
            const res = await getAdvDataList(this.params);
            const {list, total, total_info} = res.data || {};
            this.totalInfo = total_info || {};
            this.$set(this.listData, 'list', list);
            this.$set(this.listData, 'total', total);
            this.loadTable = false;
        },
        
        async getIncomeType() {
            const res = await getCommonDict({
                type: 'income_type',
            });
            this.optionTypes = res.data.options;
        },
        
        handleSearch() {
            this.params.page = 1
            this.getList();
        },
        
        handleClear() {
            this.params.page = 1
            this.filterForm = {
                dateRange: [moment().subtract(1, 'day').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD')],
                income_type: '',
                mediaIds: '',
                adslotIds: ''
            }
            this.getList()
        },
        
        handleReset() {
            const columns = [];
            const defaultValue = [];
            AllColumns.forEach((part) => {
                if (
                    (part.key === 'media' &&
                        (this.dataLevels.includes('1') || this.dataLevels.includes('2'))) ||
                    !part.dataLevels ||
                    this.dataLevels.includes(part.dataLevels)
                ) {
                    if ((['request'].includes(part.key) && this.adReqAuth) || !['request'].includes(part.key)) {
                        const selectedValue = [];
                        const children = [];
                        const allChildren = [];
                        part.children.forEach((childs) => {
                            const newChilds = [];
                            childs.forEach((child) => {
                                if (
                                    !child.dataLevels ||
                                    this.dataLevels.includes(child.dataLevels)
                                ) {
                                    const value = child.value;
                                    defaultValue.push(value);
                                    this.columnsParams.push(value)
                                    // defaultValue.push({
                                    //   key: value,
                                    //   name: child.label
                                    // })
                                    selectedValue.push(value);
                                    this.allColumnsO[value] = child;
                                    newChilds.push(child);
                                    allChildren.push(child);
                                    child.sort && this.columnsSort.push(value);
                                }
                            });
                            if (newChilds.length) {
                                children.push(newChilds);
                            }
                        });
                        columns.push({
                            ...part,
                            children,
                            isCheckAll: true,
                            selectedValue,
                            allChildren,
                        });
                    }
                }
            });
            this.columns = columns;
            console.log('defaultValue >>> ', defaultValue);
            this.$set(this.listData, 'head', defaultValue)
        },
        
        showCustomColumn() {
            this.columnVisible = true;
        },
        
        handleSortChange({prop, order}) {
            let _order = order === 'descending' ? 'desc' : 'asc';
            this.params.page = 1;
            this.params.order_by = `${prop}-${_order}`;
            this.getList();
        },
        
        async handleExport() {
            this.downloadDisable = true;
            this.formatParams();
            if (this.params && this.params.columns && this.params.columns.indexOf('os') >= 0) {
                this.params.columns = this.params.columns.replace('os', 'os_text');
            }
            const res = await downloadAdvDataList(this.params);
            this.downloadDisable = false;
            if (res.data.code) {
                this.$message.error(res.data.message);
                return;
            }
            const blob = new Blob([res.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            let reader = new FileReader();
            const me = this;
            reader.onload = function (e) {
                // reader.onload 异步回调触发 window.open，被 Safari 判定为「非用户主动触发的弹窗」，导致静默失败，改用a标签模拟点击
                // window.open(e.target.result, '_blank');
                const downloadBtn = document.createElement('a');
                downloadBtn.href = e.target.result;
                downloadBtn.style.display = 'none';
                document.body.appendChild(downloadBtn);
                downloadBtn.click();
                document.body.removeChild(downloadBtn);
                
                me.$message.success('导出成功');
            };
            reader.readAsDataURL(blob);
        },
        
        handleCheckAllChange(item, value) {
            const val = [];
            if (value) {
                item.children.flat().forEach((child) => {
                    val.push(child.value);
                });
            }
            this.$set(item, 'indeterminate', false);
            this.$set(item, 'selectedValue', val);
            this.$set(item, 'isCheckAll', value);
        },
        
        handleCheckChange(group, value) {
            let selectedValue = group.selectedValue;
            let indeterminate = false;
            let isCheckAll = false;
            if (value) {
                const allChildren = group.allChildren;
                isCheckAll = allChildren.length === selectedValue.length;
                indeterminate = !isCheckAll;
                selectedValue = allChildren
                    .filter((c) => selectedValue.includes(c.value))
                    .map((c) => c.value);
            } else {
                indeterminate = !!selectedValue.length;
            }
            this.$set(group, 'indeterminate', indeterminate);
            this.$set(group, 'selectedValue', selectedValue);
            this.$set(group, 'isCheckAll', isCheckAll);
        },
        
        handleClose() {
            this.columnVisible = false;
        },
        
        handleSubmit() {
            let values = [];
            this.columns.forEach((c) => {
                values = [...values, ...c.selectedValue];
            });
            this.$set(this.listData, 'head', values)
            this.columnsParams = values;
            this.params.page = 1
            this.getList();
            this.columnVisible = false;
        },
        
        getSummaries(param) {
            const {columns} = param;
            const sums = [];
            let keys = [];
            columns.forEach((column) => {
                keys.push(column.property);
            });
            keys.forEach((item) => {
                if (item === 'dt') {
                    sums.push('总计');
                    return;
                }
                const totalInfo = this.totalInfo;
                if (totalInfo && (totalInfo[item] || totalInfo[item] === 0)) {
                    const cellValue = this.totalInfo[item];
                    sums.push(cellValue);
                } else {
                    sums.push('-');
                }
            });
            return sums;
        },
        
        async handleMediaRemoteMethod(value) {
            const res = await getMediaByKey({
                keyword: value,
            });
            this.mediaOptions = res.data || [];
        },
        
        async handleAdslotRemoteMethod(value) {
            const {mediaIds} = this.filterForm;
            const res = await getAdslotByKey({
                keyword: value,
                media_id: mediaIds ? mediaIds.join(',') : '',
            });
            this.adslotOptions = res.data || [];
        },
        
        pageChangeHandle(page) {
            this.params.page = page
            this.getList()
        },
        
        pageSizeChangeHandle(pageSize) {
            this.params.page = 1
            this.params.page_size = pageSize
            this.getList()
        }
    }
}
</script>
